import React from 'react';
import FormInput from "../../../Components/Forms/FormInput";
import {ISA_TYPES, OPENING_OR_TRANSFERRING} from "../../../constants";
import SecondaryTitle from "../../../Components/SecondaryTitle";

const OpeningIsaDetails = (props) => {
    const {
        data = {
            'isa_type':     '',
            'isa_amount':   '',
        },
        errors      = null,
        onChange    = (field, value) => {},
        disabled    = false
    } = props;

    const handleAmountChange = (value) => {
        const newValue = `£${value.replace(/[^0-9.]/g, '')}`;
        onChange('isa_amount', newValue);
    };

    return (
        <React.Fragment>
            <SecondaryTitle>Opening</SecondaryTitle>
            <div className={'row m-0 p-0'}>
                <div className={'col-12 col-md-6 m-0 p-0 pe-md-2'}>
                    <FormInput
                        required={true}
                        name={'isa_type'}
                        detailedLabel={'Type of ISA'}
                        value={data.isa_type}
                        type={'select'}
                        options={ISA_TYPES}
                        onChange={(value) => onChange('isa_type', value)}
                        disabled={disabled}
                        error={errors}
                    />
                </div>
                <div className={'col-12 col-md-6 m-0 p-0 ps-md-2'}>
                    <FormInput
                        required={true}
                        name={'isa_amount'}
                        detailedLabel={'Amount'}
                        value={data.isa_amount}
                        type={'text'}
                        onChange={handleAmountChange}
                        disabled={disabled}
                        error={errors}
                    />
                </div>
            </div>
        </React.Fragment>
    );
}

export default OpeningIsaDetails;
